export default __webpack_public_path__ + "static/media/termsAndCondition.e90e97f0.png";